<template>
	<div class="popup popup--medium" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title" v-if="!uploadedFiles.length">Загрузить файлы</div>
				<div class="popup__title" v-else>Загруженные файлы</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<template v-if="!uploadedFiles.length">
					<div class="popup__descrtiption">Загрузите до 5 фото или один видеофайл</div>
					<div class="popup__form">
						<div class="upload-media__list">
							<div v-if="photos.length" class="u-info">
								<template v-if="fileType === 'photo'">
									Размер одного изображения не должен превышать 50 мб
								</template>
								<template v-else>
									Размер видеофайла не должен превышать 50 мб
								</template>
							</div>
							<div v-show="!photos.length" class="u-media">
								<div class="u-media__item">
									<div class="u-media__text">
										<div class="u-media__text-title">Загрузить фото</div>
										<div class="u-media__text-description">Размер одного изображения не должен превышать 50 мб</div>
									</div>
									<div class="u-media__btn">
										<button class="btn btn--border btn--gray">Загрузить</button>
										<input ref="photoInput" model class="u-media__btn-input" type="file" multiple accept="image/*" @change="setFiles">
									</div>
								</div>
								<div class="u-media__item">
									<div class="u-media__text">
										<div class="u-media__text-title">Загрузить видео</div>
										<div class="u-media__text-description">Размер видеофайла не должен превышать 50 мб</div>
									</div>
									<div class="u-media__btn">
										<button class="btn btn--border btn--gray">Загрузить</button>
										<input ref="videoInput" class="u-media__btn-input" type="file" accept="video/*"  @change="setFiles($event, 'video')">
									</div>
								</div>
							</div>
							<div v-show="photos.length" class="u-preview">
								<div class="u-preview__img" v-for="(photo,index) in photos" :key="index"
										:style="`background-image: url(${previewUrl(photo)})`">
									<span class="u-preview__img-delete" @click.stop="photos = photos.filter((item,ind) => ind !== index)"></span>
								</div>
								<div v-if="photos.length && fileType === 'photo' && photos.length < 5" class="u-preview__add" @click="handleAddMedia"></div>
							</div>

						</div>
					</div>
				</template>
				<div v-else class="popup__form">
					<div class="u-gallery">
						<div class="u-gallery__item" :class="{'u-gallery__item--video': photo.type === 'video'}" v-for="photo in files" :key="photo.id" >
							<a v-if="photo.type === 'photo'" :href="photo.file" data-fancybox="gallery" class="u-gallery__img" :style="`background-image: url(${photo.file})`"></a>
							<video v-else :src="photo.file" controls class="u-gallery__video"></video>
						</div>	
					</div>
				</div>
				<div class="popup__btns">
					<template v-if="!uploadedFiles.length ">
						<button class="btn btn--color" :disabled="!photos.length" @click.prevent="addMedia">Сохранить</button>
						<button class="btn btn--border" @click="$emit('close')">Отменить</button>
					</template>
					<button v-else-if="isSupplier" class="btn btn--border" @click="uploadedFiles = []">Загрузить другие</button>
					<button v-if="photos.length" class="btn btn--border btn--cancel" @click="clearInputs">Удалить всё</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Fancybox } from "@fancyapps/ui";
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
	name: 'UploadMediaPopup',
	emits: ['close'],
	props: {
		files: {
			type: Array,
			default: () => []
		},
		isSupplier: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			photos: [],
			fileType: 'photo',
			uploadedFiles: [],
		}
	},
	created() {
		this.uploadedFiles = this.files
	},
	mounted() {
		Fancybox.bind(this.$refs.container, '[data-fancybox]', {
			...(this.options || {}),
		});
	},
	unmounted() {
		Fancybox.destroy();
	},
	computed: {
		previewUrl() {
			return (photo) => this.fileType === 'photo' ? URL.createObjectURL(photo) : '/local/templates/nahodka/img/video-preview.png'
        },
	},
	methods: {
		setFiles(e, type = 'photo') {
			this.fileType = type
			let fileList = Array.from(e.target.files)

			const fileListFiltered = fileList.filter((file) =>  (file.size / 1024 / 1024 < 50))


			this.photos = this.photos.concat(fileListFiltered)
			if (this.photos.length > 5) {
				this.photos.length = 5
			}
			if(this.photos.length === 0) {
				this.clearInputs()
			}
		},
		addMedia() {
			this.$emit('addFiles', this.photos)
			this.$emit('close')
		},
		handleAddMedia() {
			if(this.fileType === 'photo') {
				this.$refs.photoInput.click()
			} else {
				this.$refs.videoInput.click()
			}
		},
		clearInputs() {
			this.photos = []
			this.$refs.photoInput.value = null
			this.$refs.videoInput.value = null
		}
	},

}
</script>
